import {
  Center,
  HStack,
  Text,
  Image,
  Button,
  VStack,
  Stack,
  Link as CLink,
  Icon,
} from '@chakra-ui/react';
import { ConnectButton, useConnectModal } from '@rainbow-me/rainbowkit';
import { useAccount } from 'wagmi';
import XedLogo from '../assets/exeedmelogo.svg';
import { addresses } from '../utils/contracts';
import { MdWallet } from 'react-icons/md';
import { Link } from 'react-router-dom';
import GetXEDModal from './GetXEDModal';

export default function Header() {
  const { address } = useAccount();
  const { openConnectModal } = useConnectModal();

  return (
    <VStack w="100%" spacing="0" zIndex="2">
      <HStack w="100%" justify="center" pt="3">
        <HStack
          zIndex="2"
          display={{ base: 'none', md: 'flex' }}
          fontWeight="semibold"
          bg="blackAlpha.300"
          backdropFilter="blur(50px)"
          borderRadius="full"
          justify="center"
          spacing="1"
          py="2"
          pl="2"
          pr="4"
          cursor="default"
        >
          <HStack spacing="1.5">
            <Center fontSize="10px" h="5" w="10" bg="white" color="black" borderRadius="full">
              <Text>NEW</Text>
            </Center>
            <Text fontSize="sm">XED token address:</Text>
          </HStack>
          <Text
            fontSize="sm"
            as={CLink}
            href={`https://etherscan.io/token/${addresses.token}`}
            target="_blank"
          >
            {addresses.token}
          </Text>

          <GetXEDModal>
            <Button variant="primary" size="xs" w="10" ml="2">
              Get $XED
            </Button>
          </GetXEDModal>
        </HStack>
      </HStack>
      <Stack
        direction={{ base: address ? 'column' : 'row', md: 'row' }}
        maxW="container.xl"
        w="100%"
        p="6"
        align="center"
        justify={{ base: address ? 'center' : 'space-between', md: 'space-between' }}
        spacing="4"
        zIndex="2"
      >
        <Link to="/">
          <Image w="40" src={XedLogo} alt="XED Token" zIndex="2" />
        </Link>
        {address ? (
          <ConnectButton />
        ) : (
          <Button
            borderRadius="full"
            bg="brand.500"
            _hover={{ bg: 'brand.400' }}
            color="white"
            onClick={openConnectModal}
          >
            <HStack spacing="1.5">
              <Icon as={MdWallet} fontSize="xl" />
              <Text>Connect Wallet</Text>
            </HStack>
          </Button>
        )}
      </Stack>
    </VStack>
  );
}
